import { useCart } from "../../../../app/context/cart-context/cart-context";
import { motion, } from "framer-motion";
import { useState } from "react";

import './add-to-cart-btn.css';


export const AddToCartBtn = ({productId}) => {

    const {addToCart} = useCart();
    const [clicked, setClicked] = useState(false);

    const handleButtonClick = (e, item) => {
        e.preventDefault();
        e.stopPropagation();
        if (!clicked) {
            addToCart(item);

            setClicked(true);

            setTimeout(() => setClicked(false), 3000);
        }
    }

    return (
        <motion.button className="btn" 
            onClick={(e) => handleButtonClick(e, productId)}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 0.3 } }}
            exit={{ opacity: 0, transition: { duration: 0.1 } }}
        >
            Додати
        </motion.button>
    )
}